export const potentialDuplicateEventsQueryKeys = {
  all: ["all-potential-duplicates"] as const,
  list: () => [...potentialDuplicateEventsQueryKeys.all, "list"] as const,
};
